<style scoped>
.mark {
  width: 1.0em;
  height: 1.0em;
}
</style>

<template>
  <div class="section border border-1 border-dark pt-2 pb-2 ps-2">
    <span>
      <button class="btn btn-sm btn-primary" @click="joined.panelOpened = !joined.panelOpened">
        <i class="fa fa-bars"></i>
      </button>
      <h2 class="ms-2 header">参加中リスト</h2>
      <a class="ms-2 ext-link" target="_blank" href="https://scrapbox.io/mhrise-queque/lobby-joined"><i class="fas fa-question-circle"></i></a>
    </span>
    <CollapseTransition class="mt-2 ps-4">
      <div v-show="joined.panelOpened">
        <table>
          <tr>
            <th></th>
            <th class="text-cell">メンバー種類</th>
            <th class="number-cell">参加順</th>
            <th class="number-cell">受注回数</th>
            <th class="number-cell">参加回数</th>
            <th class="mark-cell"></th> <!-- 現在のクエストホスト -->
            <th class="mark-cell"></th> <!-- 直前のクエストホスト -->
            <th class="mark-cell"></th> <!-- 順番変更ハンドラ -->
            <th class="text-cell">名前</th>
            <th class="text-cell">ハンター名</th>
            <th class="text-cell">メモ</th>
          </tr>
          <draggable v-model="joined.members" tag="tbody" handle=".handle" v-on:end='onMemberDragEnd'>
            <tr v-for="m in sortedMembers" v-bind:key="m.index">
              <td>
                <button tabindex="-1" class="btn btn-sm btn-secondary"
                  v-bind:class="{ 'btn-danger': ! isLocked(m.index) }"
                  v-on:click="onLeave(m.index)">
                  <i class="fas fa-times"></i>
                </button>
              </td>
              <td class="text-cell">
                <template v-if="m.joinedOrder == 1">
                  ロビーホスト
                </template>
                <template v-else>
                  <label>
                    <input type="checkbox" v-model="joined.members[m.index].isSupport">
                    <span class="ms-1">サポート</span>
                  </label>
                </template>
              </td>
              <td class="number-cell">{{m.joinedOrder}}</td>
              <td class="number-cell">{{m.questHostCount}}</td>
              <td class="number-cell">{{m.sortieCount}}</td>
              <td class="mark-cell">
                <template v-if="isQuestHost(m.index)">
                  <span class="mark current-quest-host-icon-mark" ></span>
                </template>
              </td>
              <td class="mark-cell">
                <template v-if="isLastQuestHost(m.index)">
                  <span class="mark last-quest-host-icon-mark" ></span>
                </template>
              </td>
              <td>
                <i class="px-2 fas fa-arrows-alt-v handle" v-show="joined.displayOrder == 'manual'"></i>
              </td>
              <td class="text-cell">
                <span class="name">{{m.name}}</span>
              </td>
              <td class="text-cell" style="min-width: 100px;" v-on:click="onBeginEdit(m.index, 'hunterName')">
                <template v-if="m.index == editIndexes.hunterName">
                  <input ref="hunterName" type="text" v-model="joined.members[m.index].hunterName"
                    v-on:keypress.enter.exact="editIndexes.hunterName = -1"
                    v-on:blur="onEndEdit(m.index, 'hunterName')"
                    >
                </template>
                <template v-else>
                  <span class="name">{{m.hunterName}}</span>
                </template>
              </td>
              <td class="text-cell" style="min-width: 100px;" v-on:click="onBeginEdit(m.index, 'memo')">
                <template v-if="m.index == editIndexes.memo">
                  <input ref="memo" type="text" v-model="joined.members[m.index].memo"
                    v-on:keypress.enter.exact="editIndexes.memo = -1"
                    v-on:blur="onEndEdit(m.index, 'memo')"
                    >
                </template>
                <template v-else>
                  <span>{{m.memo}}</span>
                </template>
              </td>
            </tr>
          </draggable>
        </table>
        <div class="mt-2">
          <button class="btn btn-sm btn-primary"
            v-bind:class="{ 'btn-secondary': joined.members.length == 0 || joined.duringQuest }"
            v-on:click="onNextQuestHost"
            >順番だけ次へ</button>
          <button class="ms-2 btn btn-sm btn-primary"
            v-bind:class="{ 'btn-secondary': joined.members.length == 0 || joined.duringQuest }"
            v-on:click="onStartQuest"
            >クエストへ出発</button>
          <button class="ms-2 btn btn-sm btn-primary"
            v-bind:class="{ 'btn-secondary': ! joined.duringQuest }"
            v-on:click="onReturnQuest"
            >クエストから帰還</button>
          <button class="ms-2 btn btn-sm btn-secondary"
            v-bind:class="{ 'btn-danger': joined.duringQuest }"
            v-on:click="onCancelQuest"
            >クエストをキャンセル</button>
        </div>
        <div class="mt-2">
          <button class="btn btn-sm btn-primary" @click="settingsOpen = !settingsOpen">
            <i class="fa fa-bars"></i>
            <span class="ms-2">設定</span>
          </button>
        </div>
        <CollapseTransition class="mt-2">
          <div v-show="settingsOpen">
            <div>
              <span>表示順</span>
              <label class="ms-2">
                <input type="radio" value="display"
                  v-model="joined.displayOrder"
                  v-on:change="onDisplayOrderChange">
                <span>ロビー表示順</span>
              </label>
              <label class="ms-2">
                <input type="radio" value="joined"
                  v-model="joined.displayOrder"
                  v-on:change="onDisplayOrderChange">
                <span>ロビー参加順</span>
              </label>
              <label class="ms-2">
                <input type="radio" value="manual"
                  v-model="joined.displayOrder"
                  v-on:change="onDisplayOrderChange">
                <span>手動で並び替え</span>
              </label>
            </div>
            <div class="mt-2">
              <span>クエストホスト種類</span>
              <label class="ms-2">
                <input type="checkbox" v-model="joined.questHostTypes.host">
                <span>ロビーホスト</span>
              </label>
              <label class="ms-2">
                <input type="checkbox" v-model="joined.questHostTypes.support">
                <span>サポート</span>
              </label>
              <label class="ms-2">
                <input type="checkbox" v-model="joined.questHostTypes.guest">
                <span>ゲスト</span>
              </label>
            </div>
            <div class="mt-2">
              <span>クエストホスト順序</span>
              <label class="ms-2">
                <input type="radio" value="display"
                  v-model="joined.questHostOrder"
                  v-on:change="onQuestHostOrderChange">
                <span>ロビー表示順</span>
              </label>
              <label class="ms-2">
                <input type="radio" value="joined"
                  v-model="joined.questHostOrder"
                  v-on:change="onQuestHostOrderChange">
                <span>ロビー参加順</span>
              </label>
              <label class="ms-2">
                <input type="radio" value="manual"
                  v-model="joined.questHostOrder"
                  v-on:change="onQuestHostOrderChange">
                <span>手動で並び替え</span>
              </label>
            </div>
            <div class="mt-2">
              <span>クエストホスト退出時</span>
              <label class="ms-2">
                <input type="radio" v-model="joined.questHostAlter" value="next">
                <span>次の人が受注</span>
              </label>
              <label class="ms-2">
                  <input type="radio" v-model="joined.questHostAlter" value="switch">
                  <span>参加回数の少ない人が受注</span>
                </label>
            </div>
            <div class="mt-2">
              <label>
                <input type="checkbox" v-model="joined.lockHostAndSupport">
                <span class="ms-1">ロビーホストとサポートをロックする</span>
              </label>
            </div>
            <div class="mt-2">
              <label>
                <input type="checkbox" v-model="joined.lockDuringQuest">
                <span class="ms-1">クエスト中はメンバーをロックする</span>
              </label>
            </div>
            <div class="mt-2">
              <button tabindex="-1" class="btn btn-danger" v-on:click="onResetCount">回数をリセット</button>
            </div>
          </div>
        </CollapseTransition>
      </div>
    </CollapseTransition>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>
</template>

<script>
import _             from 'lodash'
import draggable     from "vuedraggable"
import { CollapseTransition } from "@ivanv/vue-collapse-transition"
import JoinedMembers from '@/components/resource/JoinedMembers'

export default {
  components: {
    draggable,
    CollapseTransition,
  },
  props: {
    config: { type: Object, required: true },
    joined: { type: Object, required: false },
    others: { type: Object, required: true },
  },
  data() {
    return {
      memberTemplate: {
        displayOrder: 0,
        joinedOrder: 0,
        isSupport: false,
        questHostCount: 0,
        sortieCount: 0,
        name: '',
        hunterName: '',
        memo: '',
      },
      editIndexes: {
        hunterName: -1,
        memo: -1,
      },
      settingsOpen: false,
    }
  },
  computed: {
    sortedMembers: {
      cache: false,
      get() {
        return JoinedMembers.sortedMembers(this.joined)
      }
    },
    isLocked() {
      return (i) => {
        if (this.joined.lockHostAndSupport && this.memberType(this.joined.members[i]) == 'host') return true
        if (this.joined.lockHostAndSupport && this.memberType(this.joined.members[i]) == 'support') return true
        if (this.joined.lockDuringQuest && this.joined.duringQuest) return true
        return false
      }
    },
    isQuestHost() {
      return (i) => {
        if (! this.joined.questHost) return false
        return this.joined.members[i].name == this.joined.questHost.name
      }
    },
    isLastQuestHost() {
      return (i) => {
        if (! this.joined.lastQuestHost) return false
        return this.joined.members[i].name == this.joined.lastQuestHost.name
      }
    },
    memberType() {
      return (m) => {
        if (m.joinedOrder == 1) return 'host'
        if (m.isSupport) return 'support'
        return 'guest'
      }
    },
  },
  methods: {
    changeEntries(entries) {
      entries.forEach(entry => {
        this.joined.members.filter(m => m.name == entry.name).forEach(m => {
          m.hunterName = entry.hunterName
          m.memo = entry.memo
          m.grandTotalSortieCount = entry.grandTotalSortieCount
          m.totalSortieCount = entry.totalSortieCount
        })
      })
    },
    changeHunterNameFromChat(entries) {
      entries.forEach(entry => {
        let ms = this.joined.members.filter(m => m.name == entry.name)
        if (ms.length == 0) return

        ms.forEach(m => {
          this.$set(m, 'hunterName', entry.hunterName)
        })
      })

      this.$emit('change-entries', this.joined.members)
    },
    onMemberDragEnd() {
      this.joined.members.forEach((m, i) => {
        this.$set(this.joined.members[i], 'index', i)
      })
    },
    onLeave(i) {
      if (this.isLocked(i)) return
      
      // remove member
      this.joined.members.splice(i, 1)

      // update joined order
      this.joined.members.slice().sort((a, b) => a.joinedOrder - b.joinedOrder).forEach((m, i) => {
        m.joinedOrder = 1 + i
      })

      // update index
      this.joined.members.forEach((m, i) => {
        m.index = i
      })

      // update lobby host
      if (this.joined.members.length == 0) {
        this.joined.lobbyHost = null
      }
      else {
        this.joined.lobbyHost = this.joined.members.find(m => m.joinedOrder == 1)
        this.joined.lobbyHost.isSupport = false
      }

      // update quest host
      if (this.joined.members.includes(this.joined.questHost)) {
        return
      }

      if (this.joined.questHostAlter == 'next') {
        this.nextQuestHost()
        return
      }

      if (this.joined.questHostAlter == 'switch') {
        let h = this.joined.questHost ?? {}
        let candidate = this.questHostCandidate()
        let min = _.min(candidate.map(m => m.sortieCount))
        let sorted = candidate
          .filter(m => m.sortieCount == min)
          .sort((a, b) => a.joinedOrder - b.joinedOrder)
        let list = [
          ...sorted.filter(m => this.order(h) <= this.order(m)),
          ...sorted.filter(m => this.order(m) < this.order(h)),
          ...[this.joined.lobbyHost]
        ]
        this.joined.questHost = list[0]
        return
      }
    },
    onBeginEdit(i, fieldName) {
      this.editIndexes[fieldName] = i

      this.$nextTick(() => {
        this.$refs[fieldName][0].focus()
        this.$refs[fieldName][0].setSelectionRange(-1, -1)
      })
    },
    onEndEdit(i, fieldName) {
      this.editIndexes[fieldName] = -1
      this.$emit('change-entries', [this.joined.members[i]])
    },
    onNextQuestHost() {
      if (this.joined.members.length == 0) return
      if (this.joined.duringQuest) return

      this.nextQuestHost();
    },
    onStartQuest() {
      if (this.joined.members.length == 0) return
      if (this.joined.duringQuest) return

      this.joined.duringQuest = true

      // update sortie count
      this.joined.members.forEach(m => {
        m.sortieCount = m.sortieCount ? m.sortieCount + 1 : 1
        m.grandTotalSortieCount = m.grandTotalSortieCount ? m.grandTotalSortieCount + 1 : 1
        m.totalSortieCount = m.totalSortieCount ? m.totalSortieCount + 1 : 1
      })

      // update quest host count
      if (this.joined.questHost) {
        this.joined.questHost.questHostCount++
      }

      this.$emit('change-entries', this.joined.members)
    },
    onReturnQuest() {
      if (! this.joined.duringQuest) return

      this.joined.duringQuest = false
      this.joined.lastQuestHost = this.joined.questHost

      // update quest host
      this.nextQuestHost()
    },
    onCancelQuest() {
      if (! this.joined.duringQuest) return
      
      this.joined.duringQuest = false

      // update sortie count
      this.joined.members.forEach(m => {
        m.sortieCount = m.sortieCount ? m.sortieCount - 1 : 0
        m.grandTotalSortieCount = m.grandTotalSortieCount ? m.grandTotalSortieCount - 1 : 0
        m.totalSortieCount = m.totalSortieCount ? m.totalSortieCount - 1 : 0
      })

      // update quest host count
      if (this.joined.questHost) {
        this.joined.questHost.questHostCount = this.joined.questHost.questHostCount ? this.joined.questHost.questHostCount - 1 : 0
      }

      this.$emit('change-entries', this.joined.members)
    },
    onDisplayOrderChange() {
      if (this.joined.displayOrder == 'manual' && this.joined.questHostOrder != 'manual') {
        this.$set(this.joined, 'questHostOrder', 'manual')
      }
      if (this.joined.displayOrder != 'manual' && this.joined.questHostOrder == 'manual') {
        this.$set(this.joined, 'questHostOrder', this.joined.displayOrder)
      }
    },
    onQuestHostOrderChange() {
      if (this.joined.questHostOrder == 'manual' && this.joined.displayOrder != 'manual') {
        this.$set(this.joined, 'displayOrder', 'manual')
      }

      if (this.joined.questHostOrder != 'manual' && this.joined.displayOrder == 'manual') {
        this.$set(this.joined, 'displayOrder', this.joined.questHostOrder)
      }
    },
    onResetCount() {
      this.joined.members.forEach(m => {
        m.sortieCount = 0
        m.questHostCount = 0
      })
    },
    addJoined(entry) {
      let n = this.joined.members.length
      let displayOrder = _.difference(
          [...Array(this.config.maxJoinedMemberCount)].map((_, i) => 1 + i),
          this.joined.members.map(m => m.displayOrder))[0] ?? 1
      let joinedOrder = n + 1

      let newMember = {
        ...this.memberTemplate, 
        ...{
          index: this.joined.members.length,
          displayOrder: displayOrder,
          joinedOrder: joinedOrder,
        },
        ...entry,
      }
      this.joined.members.push(newMember)

      // update lobby host
      this.joined.lobbyHost = this.joined.members.find(m => m.joinedOrder == 1)
      this.joined.lobbyHost.isSupport = false
      
      // update quest host
      if (this.joined.members.length == 1) {
        this.joined.questHost = newMember
        return
      }
    },
    nextQuestHost() {
      if (this.joined.members.length == 0) {
        this.joined.questHost = null
        return
      }

      if (this.joined.members.length == 1) {
        this.joined.questHost = this.joined.members[0]
        return
      }

      let h = this.joined.questHost ?? {}
      let sorted = this.questHostCandidate()
        .sort((a, b) => this.order(a) - this.order(b))
      
      let list = [
        ...sorted.filter(m => this.order(h) <= this.order(m)),  // 現在のクエストホストより後の人達
        ...sorted.filter(m => this.order(m) <  this.order(h)),  // 現在のクエストホストより前の人達
        ...[this.joined.questHost],                             // 現在のホスト以外誰もホストになれる人が居ない場合のため
      ]

      this.joined.questHost = list[0]
    },
    questHostCandidate() {
      let h = this.joined.questHost ?? {}
      let types = this.joined.questHostTypes
      let candidate = this.joined.members
        .filter(m => (types.host    && this.memberType(m) == 'host'   ) ||
                     (types.support && this.memberType(m) == 'support') ||
                     (types.guest   && this.memberType(m) == 'guest'  ))
        .filter(m => m.name != h.name)


      return candidate
    },
    order(m) {
      return JoinedMembers.questHostOrder(this.joined, m)
    },
  }
}
</script>
